import locationBaseController from "../location.base.controller";
import AppConstants from '../../../../config/app.constants'

var lastErrorIndex = -1;
class DeliverLocationController extends locationBaseController {

    /*@ngInject*/
    constructor(Modal, $stateParams, $translate, $q, Auth, $state, $scope, ShiptypeService, LocationService) {
        super(Auth, $state, Modal, $translate, $stateParams, $scope);
        this.$q = $q;
        this.ShiptypeService = ShiptypeService;
        this.LocationService = LocationService;
        this.$translate = $translate;
        this.selectedDelLocationOptions = [];
        this.allLocations = [];
        this.allShipTypes = [];
        this.$scope = $scope;
        this.oldBranchLocation = [];
    }

    $onInit() {
        this.getAllShipType('', 0);
        this.$scope.$watch(() => {
            return this.model.branch;
        }, (newValue, oldValue) => {
            if (newValue && newValue.length > 0) {
                if (newValue != oldValue && this.isEdit) {
                    this.model.deliveryToLocation.map((obj, index) => {
                        this.model.deliveryToLocation[index].allLocations = [];
                        // this.model.deliveryToLocation[index].location = null;
                        // this.model.deliveryToLocation[index].locationDetails = null;
                        this.model.deliveryToLocation[index].totalLocation = 0;
                    })
                    this.isDataShift = false;
                    this.loadLocation('', 0);
                    this.checkDuplicateEntry();
                } else {
                    // if (this.model.deliveryToLocation) {
                    //     this.model.deliveryToLocation.map((d) => {
                    //         const allShipType = [{ Key: this.$translate.instant('location.all_coin'), Value: 'all coin' }]
                    //         d.allShipeType = allShipType.concat(d.allShipeType)
                    //     })
                    // }
                    this.isDataShift = true;
                    this.loadLocation('', 0);
                }
            } else {
                if (this.model && this.model.deliveryToLocation && this.model.deliveryToLocation.length) {
                    this.model.deliveryToLocation.map((location, index) => {
                        this.totalLocationRecords = this.model.deliveryToLocation[index].locationDetails ? 1 : 0;
                        this.allLocations = this.model.deliveryToLocation[index].locationDetails ? this.mappingArray([this.model.deliveryToLocation[index].locationDetails], '', null, 'setDeliverToLocation') : [];
                    });
                }
            }
            this.updatePickupRequirement();
        });
    }

    locationSearchObj(searchKey) {
        let selectedBranch = Array.isArray(this.model.branch) ? this.model.branch.map((branch) => branch.branchId) : this.model.branch.split();
        searchKey = searchKey || '';
        const searchObj = {
            queryJSON: {
                rules: [
                {
                group: {
                    operator: 'OR',
                    rules: [
                        {
                            field: 'centralBank',
                            condition: '!=',
                            data: 0
                        },
                        {
                            group: {
                                operator: 'AND',
                                rules: [
                                    {
                                        field: 'centralBank',
                                        condition: '=',
                                        data: 0
                                    },
                                    {
                                        field: 'id',
                                        condition: '!=',
                                        data: this.model.id
                                    }
                                ]
                            }
                        }
                    ]
                }
                },
                {
                    field: 'branchId',
                    condition: 'IN',
                    data: selectedBranch
                },
                {
                    field: 'active',
                    condition: '=',
                    data: true
                },
                {
                    group: {
                        rules: [{
                            field: 'id',
                            condition: 'like',
                            data: '%' + searchKey + '%'
                        },
                        {
                            field: 'name',
                            condition: 'like',
                            data: '%' + searchKey + '%'
                        }
                        ],
                        operator: 'OR'
                    }
                },
                {
                    group: {
                        rules: [
                            {
                                field: 'locationType',
                                condition: '=',
                                data: 'DELIVERY'
                            }, 
                            {
                                field: 'locationType',
                                condition: '=',
                                data: 'BANK'
                            },
                            {
                                field: 'locationType',
                                condition: '=',
                                data: 'ATM'
                            },
                            {
                                field: 'locationType',
                                condition: '=',
                                data: 'REGULAR'
                            },
                            {
                                field: 'locationType',
                                condition: '=',
                                data: 'ON_CALL'
                            },
                            {
                                field: 'locationType',
                                condition: '=',
                                data: 'NO_SHIP_NO_GO'
                            },
                            {
                                field: 'locationType',
                                condition: '=',
                                data: 'VAULT'
                            }
                        ],
                        operator: 'OR',
                    }
                }
                ],
                operator: 'AND'
            }
        };
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    loadLocation(searchKey, offset) {
        var locationSearchObj = this.locationSearchObj(searchKey);
        this.LocationService.all(locationSearchObj, offset, AppConstants.defaultPageLimit)
            .then((res) => {
                if (offset === 0) {
                    this.totalLocationRecords = res.total;
                    this.allLocations = this.mappingArray(res.results, '', null, 'location');
                    if (this.isEdit && !this.isDataShift) {
                        this.model.deliveryToLocation.map((location, index) => {
                            this.model.deliveryToLocation[index].totalLocation = res.total;
                            this.model.deliveryToLocation[index].allLocations = this.mappingArray(res.results, '', null, 'location');
                        })
                    }
                } else {
                    const locations = this.mappingArray(res.results, '', null, 'location');
                    this.allLocations = this.allLocations.concat(locations);
                }
            })
    }

    shipTypeSearchObj(searchKey) {
        searchKey = searchKey || '';
        const searchObj = {
            queryJSON: {
                rules: [
                    {
                        field: 'status',
                        condition: '=',
                        data: true
                    },
                    {
                        group: {
                            rules: [
                                {
                                    field: 'description',
                                    condition: 'like',
                                    data: '%' + searchKey + '%'
                                }],
                            operator: 'AND'
                        }
                    }
                ],
                operator: 'AND'
            }
        };
        return searchObj.queryJSON.rules.length ? searchObj : null;
    }

    getAllShipType(searchKey, offset) {
        var shipTypeSearchObj = this.shipTypeSearchObj(searchKey);
        this.ShiptypeService.all(shipTypeSearchObj, offset, AppConstants.defaultPageLimit)
            .then((data) => {

                this.allCoinShipType = [
                    { Key: this.$translate.instant('location.all_coin'), Value: 'all coin' }
                ];

                if (data.results) {
                    if (offset === 0) {
                        this.totalShipTypeRecords = data.total;
                        this.allShipType = this.mappingArray(data.results, '', null, 'shipType');
                        this.allShipTypes = this.allCoinShipType.concat(this.allShipType);
                    } else {
                        const shiptype = this.mappingArray(data.results, '', null, 'shipType');
                        this.allShipTypes = this.allShipTypes.concat(shiptype);
                    }
                }
            })
    }

    getEditShipType(searchKey, offset, index) {
        if (this.isEdit) {
            if (offset !== 0 && this.model.deliveryToLocation && !searchKey && Math.abs(offset % 2) == 1) {
                offset = offset - 1;
            }
        }
        var shipTypeSearchObj = this.shipTypeSearchObj(searchKey);
        this.ShiptypeService.all(shipTypeSearchObj, offset, AppConstants.defaultPageLimit)
            .then((data) => {
                let selectedVal = this.model.deliveryToLocation[index].shipTypeDetails ? this.model.deliveryToLocation[index].shipTypeDetails.Value : '';
                if (data.results) {
                    if (offset === 0) {
                        this.model.deliveryToLocation[index].totalShipment = data.total
                        this.model.deliveryToLocation[index].allShipeType = this.mappingArray(data.results, searchKey, selectedVal, 'shipType');
                    } else {
                        const shiptype = this.mappingArray(data.results, searchKey, selectedVal, 'shipType');
                        this.model.deliveryToLocation[index].allShipeType = this.model.deliveryToLocation[index].allShipeType.concat(shiptype);
                    }
                }
            })
    }

    mappingArray(mapArray, searchKey, originalVal, type) {
        let newArray = [];
        mapArray.map((obj) => {

            if (type == 'shipType') {
                obj.Key = obj.description;
            }
            else if(type === 'setDeliverToLocation') {
                obj.Key = obj.Key //+ ' | ' + obj.Value;
            }
            else {
                obj.Key = obj.id + ' | ' + obj.name;
            }
            obj.Value = obj.id || obj.Value;
            if (!searchKey && originalVal) {
                if (obj.id !== originalVal) {
                    newArray.push(obj);
                }
            } else {
                newArray.push(obj);
            }
        });
        return newArray;
    }

    loadEditLocation(searchKey, offset, index) {
        searchKey = searchKey || '';
        var locationSearchObj = this.locationSearchObj(searchKey);
        if (this.isEdit) {
            if (offset !== 0 && this.model.deliveryToLocation && !searchKey && Math.abs(offset % 2) == 1) {
                offset = offset - 1;
            }
        }
        this.LocationService.all(locationSearchObj, offset, AppConstants.defaultPageLimit)
            .then((res) => {
                let selectedVal = this.model.deliveryToLocation[index].locationDetails ? this.model.deliveryToLocation[index].locationDetails.Value : '';
                let deliveryToLocation = this.model.deliveryToLocation[index].locationDetails ? this.model.deliveryToLocation[index].locationDetails.Key : '';

                let locationDetails = {
                    Key: deliveryToLocation,
                    Value: selectedVal
                }

                if (offset === 0) {
                    this.model.deliveryToLocation[index].totalLocation = res.total
                    this.model.deliveryToLocation[index].allLocations = this.mappingArray(res.results, searchKey, null, 'location');
                    if (!searchKey) {
                        this.model.deliveryToLocation[index].allLocations.unshift(locationDetails);
                    }
                } else {
                    const locations = this.mappingArray(res.results, searchKey, null, 'location');
                    this.model.deliveryToLocation[index].allLocations = this.model.deliveryToLocation[index].allLocations.concat(locations);
                }
            })
    }

    addDeliverLocationOption() {
        if (this.model.deliveryToLocation == undefined) this.model.deliveryToLocation = [];
        var locationSearchObj = this.locationSearchObj('');
        var shipTypeSearchObj = this.shipTypeSearchObj('');

        this.$q.all([
            this.LocationService.all(locationSearchObj, 0, AppConstants.defaultPageLimit),
            this.ShiptypeService.all(shipTypeSearchObj, 0, AppConstants.defaultPageLimit)
        ]).then((data) => {

            let locations = this.mappingArray(data[0].results, '', null, 'location');
            let shiptypes = this.mapShiptypeArray(data[1].results, '', null);
            const allCoinShipType = [
                { Key: this.$translate.instant('location.all_coin'), Value: 'all coin' }
            ];
            const allShipTypes = allCoinShipType.concat(shiptypes);
            this.model.deliveryToLocation.push({
                shipType: null,
                shipTypeDetails: null,
                location: null,
                locationDetails: null,
                duplicate: false,
                totalLocation: data[0].total,
                allLocations: locations,
                totalShipment: data[1].total || 0,
                allShipeType: allShipTypes,
                sortOrder: this.model.deliveryToLocation.length,
                individualDelivery: false,
                pickupRequired: false,
                disablePickupRequire: false
            });
            if (this.model.deliveryToLocation.length > 1) {
                this.checkDuplicateEntry()
            }
        })
    }

    updatePickupRequirement() {
        if (!this.model.deliveryToLocation || this.model.deliveryToLocation.length === 0) return;

        const duplicate = {};

        this.model.deliveryToLocation.forEach(item => {
            if (item.shipTypeDetails) {
                const key = `${item.shipTypeDetails.Value}`;

                if (duplicate[key]) {
                    duplicate[key].push(item);
                } else {
                    duplicate[key] = [item];
                }
            }
        });

        for (const key in duplicate) {
            if (duplicate[key].length > 1) {
                duplicate[key].forEach(item => {
                    item.disablePickupRequire = true;
                    item.pickupRequired = false;
                });
            }
            else {
                duplicate[key].forEach(item => {
                    item.disablePickupRequire = false;
                });
            }
        }
    }

    mapShiptypeArray(mapArray, searchKey, originalVal) {
        let newArray = [];
        mapArray.map((obj) => {
            obj.Key = obj.description;
            obj.Value = obj.id;
            if (!searchKey && originalVal) {
                if (obj.id !== originalVal) {
                    newArray.push(obj);
                }
            } else {
                newArray.push(obj);
            }
        });
        return newArray;
    }

    removeDeliverLocationOption(location, index) {
        this.model.deliveryToLocation.splice(index, 1);
        if (this.model.locationToBeUpdated && this.model.locationToBeUpdated.length) {
            const locIndex = _.findIndex(this.model.locationToBeUpdated, { locationId: location.locationDetails.Value, shiptypeId: location.shipTypeDetails.Value });
            this.model.locationToBeUpdated.splice(locIndex, 1);
        }
        this.checkDuplicateEntry();
        this.updatePickupRequirement();
    }

    checkDuplicateEntry() {
        this.model.deliveryToLocation = _.map(this.model.deliveryToLocation, (mainObj, mainObjIndex) => {
            mainObj.duplicate = false;
            mainObj.location = mainObj.locationDetails ? mainObj.locationDetails.Value : null;
            mainObj.shipType = mainObj.shipTypeDetails ? mainObj.shipTypeDetails.Value : null;
            let eq = _.find(this.model.deliveryToLocation, (compairObject, compairObjIndex) => {
                compairObject.location = compairObject.locationDetails ? compairObject.locationDetails.Value : null;
                compairObject.shipType = compairObject.shipTypeDetails ? compairObject.shipTypeDetails.Value : null;
                if (mainObjIndex > compairObjIndex) {
                    return (compairObject.shipType == mainObj.shipType && compairObject.location == mainObj.location);
                }
            });
            if (eq) {
                mainObj.duplicate = true;
                return mainObj;
            } else {
                return mainObj;
            }
        });
        let checkValidDirective = this.model.deliveryToLocation.map((obj) => {
            if (obj.duplicate) return true;
        })
        this.isValidDirective = checkValidDirective.indexOf(true) >= 0 ? false : true;
    }
}

export default DeliverLocationController;



// WEBPACK FOOTER //
// ./client/app/components/location/common/deliver_location/deliver_location.controller.js